import { createAsyncThunk } from '@reduxjs/toolkit';

import { addToFavorite } from '../../services/favorites/addToFavorite/addToFavorite';
import { deleteFromFavorite } from '../../services/favorites/deleteFromFavorite/deleteFromFavorite';
import { addNotification } from '../../slices';
import { ENotificationType } from '../../types/notifications';
import { IOffer } from 'shared/types/offers';
import { IThunkApi } from 'shared/types/redux';
import { getEntityType } from 'shared/utils/favorites/helpers';

export const updateFavoriteStatusOffer = createAsyncThunk<void, IOffer, IThunkApi>(
  'favorites/updateFavoriteStatusOffer',
  async (offer, { dispatch, getState }) => {
    const { user } = getState();

    const { id, dealType, offerType } = offer;

    const errorText = offer.isFavorite ? 'Не удалось удалить из избранного' : 'Не удалось добавить в избранное';

    if (!id || !dealType) {
      dispatch(addNotification({ type: ENotificationType.Error, text: errorText }));

      return;
    }

    try {
      const entityType = getEntityType(offerType);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const currentCount = (window as any).__header_favorites_count__ || 0;

      if (user.isAuthenticated) {
        const action = offer.isFavorite ? deleteFromFavorite : addToFavorite;
        dispatch(action({ offerId: id, dealType, entityType, currentCount }));
      } else {
        if (window.waitForLoginPopup) {
          window.waitForLoginPopup('favorites');
        }
      }
    } catch {
      dispatch(addNotification({ type: ENotificationType.Error, text: errorText }));
    }
  },
);
